(() => {
  const forms = [...document.querySelectorAll('[data-nura-proxy-form]')];
  if (!forms.length) return;

  const endpoint = (form) => form.dataset.nuraProxyUrl || '';

  const show = (box, text) => {
    if (!box) return;
    box.textContent = text || '';
    box.hidden = false;
  };
  const hideAll = (container) => {
    container.querySelectorAll('[data-nura-success]').forEach((el) => { el.hidden = true; });
    container.querySelectorAll('[data-nura-error]').forEach((el) => { el.hidden = true; });
  };

  forms.forEach((form) => {
    const container = form.closest('.nura-system__contact-card') || form.parentElement;
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      hideAll(container);
      const url = endpoint(form);
      const btn = form.querySelector('button[type="submit"]');
      const success = container.querySelector('[data-nura-success]');
      const error = container.querySelector('[data-nura-error]');

      const fd = new FormData(form);
      const payload = {
        name: (fd.get('name') || '').trim(),
        email: (fd.get('email') || '').trim(),
        topic: (fd.get('topic') || '').trim(),
        order_number: (fd.get('order_number') || '').trim(),
        last4: (fd.get('last4') || '').trim(),
        message: (fd.get('message') || '').trim(),
      };

      if (!payload.email || !payload.message) {
        show(error, 'Please fill in your email and your message.');
        return;
      }

      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }

      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        const data = await res.json().catch(() => ({ ok: false }));
        if (res.ok && data.ok) {
          if (success) { success.hidden = false; }
          form.hidden = true;
        } else {
          show(error, 'Something went wrong. Please email contact@mynura.reamaze.com and we will get right back to you.');
        }
      } catch (_) {
        show(error, 'Something went wrong. Please email contact@mynura.reamaze.com and we will get right back to you.');
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = original; }
      }
    });
  });
})();
